"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailSentiment = exports.SubjectMatchMinLength = void 0;
exports.SubjectMatchMinLength = 10;
var EmailSentiment;
(function (EmailSentiment) {
    EmailSentiment[EmailSentiment["Negative"] = 0] = "Negative";
    EmailSentiment[EmailSentiment["Unknown"] = 1] = "Unknown";
    EmailSentiment[EmailSentiment["Positive"] = 2] = "Positive";
})(EmailSentiment = exports.EmailSentiment || (exports.EmailSentiment = {}));
//# sourceMappingURL=communication.js.map